import React, { useEffect, useState } from "react";
import Pagination from "@material-ui/lab/Pagination";
import { Button, TextField } from "@material-ui/core";
import axiosInstance from "../../services/AxiosInstance";
import axios from "axios";
import { ApiURL } from "../../constants/ApiUrl";
import "../../styles/AdminMembers.css";
import * as XLSX from "xlsx";

function formatMemberOnForExport(value) {
  if (value == null || value === "") return "";
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) return d.toLocaleDateString();
  return String(value);
}

function CoupleList() {
  const [couples, setCouples] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalResults, setTotalResults] = useState(0);
  const [loading, setLoading] = useState(false);
  const limit = 50;

  const fetchCouples = async (currentPage = 0, query = "") => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${ApiURL}/api/getAllCoupleMembers`,
        {
          params: {
            page: currentPage,
            limit,
            search: query,
          },
        }
      );
      const { data, totalPages, totalItems } = response.data;
      setCouples(data);
      setTotalPages(totalPages);
      setTotalResults(totalItems);
    } catch (error) {
      console.error("Error fetching couple members:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCouples(page, search);
  }, [page]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = () => {
    setPage(0);
    fetchCouples(0, search);
  };

  const handlePageChange = (_, value) => {
    setPage(value - 1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  const handleRefresh = () => {
    setSearch("");
    setPage(0);
    fetchCouples(0, "");
  };

  const handleView = (id) => {
    window.open(`/admin/couple/members/${id}`, "_blank", "noopener,noreferrer");
  };

  // download data
  const downloadAllCouplesExcel = async () => {
    try {
      console.log("working inside download couples");
      const res = await axiosInstance.get(
        `${ApiURL}/api/downloadAllCouplesData`,
        {
          params: {
            search,
          },
        }
      );

      const data = res.data.data || [];

      const sheetRows = data.map((row) => {
        const { memberOn1, memberOn2, ...rest } = row;
        return {
          ...rest,
          memberOn1: formatMemberOnForExport(memberOn1),
          memberOn2: formatMemberOnForExport(memberOn2),
        };
      });

      const ws = XLSX.utils.json_to_sheet(sheetRows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Couples");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const dd = new Date();
      link.download = `CoupleMembers-${dd.getDate()}-${
        dd.getMonth() + 1
      }-${dd.getFullYear()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading couples Excel:", error);
    }
  };

  return (
    <div className="admMem">
      <h1>Couple Members List</h1>
      <div className="searchContainer" style={{ width: "50%", gap: "20px" }}>
        <TextField
          style={{ width: "70%" }}
          placeholder="Search"
          label="Doctor Name or Membership ID"
          value={search}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
        />
        <Button
          variant="contained"
          style={{ height: "40px" }}
          onClick={handleSearchSubmit}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          style={{ height: "40px" }}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
        <Button
          variant="contained"
          color="secondary"
          style={{ height: "40px" }}
          onClick={downloadAllCouplesExcel}
        >
          <i class="fa fa-download"></i>
        </Button>
      </div>

      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={handlePageChange}
        variant="outlined"
        shape="rounded"
        style={{ marginTop: "1rem" }}
      />
      <p>
        <b>{totalResults} couple records found.</b>
      </p>

      <table className="appTable">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Membership ID</th>
            <th>Doctor Name (spouse 1)</th>
            <th>Doctor Name (spouse 2)</th>
            <th>NMO State</th>
            <th>Member Since</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          ) : couples.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No records found.
              </td>
            </tr>
          ) : (
            couples.map((item, index) => (
              <tr key={item.appId}>
                <td>{page * limit + (index + 1)}</td>
                <td>
                  {item.mem_no1} / {item.mem_no2}
                </td>
                <td>{item.name1}</td>
                <td>{item.name2}</td>
                <td>{item.nmo_state}</td>
                <td>
                  {item.memberOn
                    ? new Date(item.memberOn).toLocaleDateString()
                    : "—"}
                </td>
                <td
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  {item.memberID1 && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleView(item.memberID1, item.name1)}
                    >
                      View for {item.name1}
                    </Button>
                  )}
                  {item.memberID2 && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleView(item.memberID2, item.name2)}
                    >
                      View for {item.name2}
                    </Button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CoupleList;
